 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/CoverPage'
 import HALFTITLEPAGE from '@/components/HalfTitlePage'
 import ALSOBYHARRISONOWEN from '@/components/AlsobyHarrisonOwen'
 import TITLEPAGE from '@/components/TitlePage'
 import COPYRIGHTPAGE from '@/components/CopyrightPage'
 import DEDICATION from '@/components/Dedication'
 import PREFACE from '@/components/Preface'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import CHAPTER5 from '@/components/Chapter5'
 import CHAPTER6 from '@/components/Chapter6'
 import CHAPTER7 from '@/components/Chapter7'
 import CHAPTER8 from '@/components/Chapter8'
 import CHAPTER9 from '@/components/Chapter9'
 import CHAPTER10 from '@/components/Chapter10'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER12 from '@/components/Chapter12'
 import ADDITIONALRESOURCES from '@/components/AdditionalResources'
 import INDEX from '@/components/Index'
 import ABOUTTHEAUTHOR from '@/components/AbouttheAuthor'
 import ABOUTBERRETTKOEHLERPUBLISHERS from '@/components/AboutBerrettKoehlerPublishers'
 import BECONNECTED from '@/components/BeConnected'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverPage",
 			"name" : "CoverPage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/HalfTitlePage",
 			"name" : "HalfTitlePage",
 			"component" : HALFTITLEPAGE
 		},
 		{
 			"path" : "/AlsobyHarrisonOwen",
 			"name" : "AlsobyHarrisonOwen",
 			"component" : ALSOBYHARRISONOWEN
 		},
 		{
 			"path" : "/TitlePage",
 			"name" : "TitlePage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/CopyrightPage",
 			"name" : "CopyrightPage",
 			"component" : COPYRIGHTPAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Preface",
 			"name" : "Preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/Chapter2",
 			"name" : "Chapter2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js